export default __webpack_public_path__ + "static/media/portrait6.7e7f1756.JPG";